import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITableTemplate } from '@shared/services/docs.service';

@Component({
	templateUrl: './confirmDialogContent.component.html',
	styleUrls: ['./confirmDialogContent.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TemplateDeleteConfirmDialogContentComponent {
	@Input()
	public templates: ITableTemplate[] = [];

	@Input()
	public permanent: boolean = false;
}
